function Header() {
  let sticky = 0;
  let header = document.querySelector("header");
  if (document.querySelector(".header")) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener("scroll", (event) => {
      stickyHeader();
    });
  }
}

export default Header;
